import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";

import { secondsToMinutesAndSeconds } from "../../../../../helpers/MathHelpers";

interface TimeAtPositionProps {
  seekHoverPosition: number;
  trackWidth: number;
  videoDuration: number;
}

export default observer(function TimeAtPosition(props: TimeAtPositionProps) {
  const { seekHoverPosition, trackWidth, videoDuration } = props;

  const timeAtHoveredPosition = useMemo(() => {
    let percent: number = (seekHoverPosition * 100) / trackWidth;
    let seconds: number = Math.round(+(percent * (videoDuration / 100)));
    let time: string = secondsToMinutesAndSeconds(seconds);

    return time;
  }, [seekHoverPosition, trackWidth, videoDuration]);

  return <div>{timeAtHoveredPosition}</div>;
});
